import { render } from "./App.vue?vue&type=template&id=69a2a1c6"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=69a2a1c6&lang=css"

import exportComponent from "/Users/yxgc/Documents/workspace/BeeUiComentPlugin/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.18_vue@3.5.18_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__